// extracted by mini-css-extract-plugin
export default {"slide-in":"dropdown-nav-animationes_slide-in__ibe-q"};